import Vue from 'vue';
import VueCompositionApi from '@vue/composition-api';
Vue.use(VueCompositionApi);
import App from './App.vue';
import './assets/tailwind.css';
Vue.config.productionTip = false;
new Vue({
    render: function (h) { return h(App); }
}).$mount('#app');
